export default "__VITE_ASSET__CEkm6_q3__"